import type { CourseModule } from "@/core/types";
import { lektionTextfunktionen } from "./lektion-01-text";
import { lektionDatumsfunktionen } from "./lektion-02-datum";
import { lektionLogik } from "./lektion-03-logik";
import { lektionIndexVergleich } from "./lektion-04-index";
import { lektionDynamischeArrays } from "./lektion-05-dynamisch";

/**
 * Die Funktionsgruppen der Registerkarte „Formeln“, die über SUMME, WENN und
 * SVERWEIS hinausgehen. Alle Aufgaben laufen über die Formelanalyse aus
 * `formeln.ts` und brauchen nur ExcelApi 1.4.
 */
export const modulFunktionenAufbau: CourseModule = {
  id: "funktionen-aufbau",
  title: "Weitere Funktionen",
  summary:
    "Text zerlegen und bereinigen, mit Datumswerten rechnen, mehrere Bedingungen " +
    "verknüpfen, INDEX/VERGLEICH und die dynamischen Arrays FILTER, EINDEUTIG und SORTIEREN.",
  level: "Aufbau",
  lessons: [lektionTextfunktionen, lektionDatumsfunktionen, lektionLogik, lektionIndexVergleich, lektionDynamischeArrays],
};
